import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { fetchHomeNew } from "../../states/actions/fetchHomeNew";
import { useSelector, useDispatch } from "react-redux";
import { fetchSiteSettings } from '../../states/actions/fetchSiteSettings';
import useDocumentTitle from "../../hooks/useDocumentTitle";
import LoadingScreen from "../common/LoadingScreen";


import ToggleTabs from "../common/tab";
import Footer_new from "../common/footer";
import { getServerImage } from "../../helpers/api";
import SearchForm from "./section/search-form";
import Text from "../common/Text";


export default function HomeNew() {

  const dispatch = useDispatch();
    const data = useSelector((state) => state.fetchHomeNew.content);
    const isLoading = useSelector((state) => state.fetchHomeNew.isLoading);

    useEffect(() => {
        dispatch(fetchHomeNew());
    }, []);
    const {content,renter_blocks,landlord_blocks,page_title,siteSettings} = data;
    useDocumentTitle((data.page_title) ? data.page_title : data.page_title, (siteSettings) ? siteSettings.site_name : 'Loftus');
    if (isLoading) return <LoadingScreen />;
    console.log(content)
    const keys = [2, 3, 4, 5];
    const items = keys.map(num => ({
      heading: content[`block_heading_${num}`],
      text: content[`block_text_${num}`],
      image: content[`image${num}`],
    }));
    console.log(items)
  return (
    <>
      <section className="banner" style={{ backgroundImage: `url(${getServerImage("storage/images/",content?.image1)})` }}>
        <div className="contain">
          <div className="cntnt text-center">
            <h1>{content?.banner_heading}</h1>
            <p>
              {content?.banner_text}
            </p>
          </div>
          <div className="banner-form">
            <SearchForm text={content.search_text} />
          </div>
        </div>
      </section>

      <section className="feature_icon new_features">
        <div className="contain">
          <div className="flex">
            {items.map((item, index) => (
              <div className="col" key={index}>
                <div className="inner">
                  <div className="image">
                    <img src={`${getServerImage("storage/images/",item.image)}`} alt={item.heading} />
                  </div>
                  <h4>{item.heading}</h4>
                  <p>{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="tab_sec">
        <div className="contain">
          <div className="content_center">
            <Text string={content?.featured_text} />
          </div>
          <ToggleTabs content={content} renter_blocks={renter_blocks} landlord_blocks={landlord_blocks} />
        </div>
      </section>
    </>
  );
}
